import '../../sass/layout/sections/layers-earth.scss';


document.addEventListener("DOMContentLoaded", function () {
    const layers = document.querySelectorAll(".layers-wrapper > a");
    let activeLayer = null; 

    function activateLayer(layer) {
        let clickedZIndex = parseInt(window.getComputedStyle(layer).zIndex, 10);

        layers.forEach((otherLayer, index) => {
            otherLayer.style.transition = "margin 0.6s ease-in-out"; 
            otherLayer.style.marginBottom = "0";
            otherLayer.classList.remove("active");

            if (index === 0) {
                otherLayer.style.marginTop = "0px";
            } else {
                otherLayer.style.marginTop = "-65px";
            }

            const desc = otherLayer.querySelector(".layer-desc");
            if (desc) {
                desc.style.transition = "opacity 0.6s ease-in-out";
                desc.style.opacity = "0";
            }
        });

        activeLayer = layer;
        layer.classList.add("active");

        layers.forEach(otherLayer => {
            let otherZIndex = parseInt(window.getComputedStyle(otherLayer).zIndex, 10);

            if (otherZIndex == 11) {
                otherLayer.style.marginTop = "0";
            } else if (otherZIndex == 1) {
                otherLayer.style.marginTop = "-65px";
            } else {
                otherLayer.style.marginTop = "-65px";
            }
        });

        if (clickedZIndex == 1) {
            layer.style.marginTop = "40px";
        } else if (clickedZIndex == 11) {
            layer.style.marginTop = "0";
            layer.style.marginBottom = "105px";
        } else {
            layer.style.marginTop = "-5px";
            layer.style.marginBottom = "45px";
        }

        const desc = layer.querySelector(".layer-desc");
        if (desc) {
            setTimeout(() => {
                desc.style.opacity = "1";
            }, 400);
        }
    }

    setTimeout(() => {
        const defaultLayer = [...layers].find(layer => 
            parseInt(window.getComputedStyle(layer).zIndex, 10) === 7
        );

        if (defaultLayer) {
            activateLayer(defaultLayer);
        }
    }, 200);

    layers.forEach(layer => {
        layer.addEventListener("click", function () {
            if (this === activeLayer) return; 
            activateLayer(this);
        });
    });
});
